import { useLayoutEffect } from 'react'
import MonacoEditor, { useMonaco } from '@monaco-editor/react'

import { darkTheme, monacoOptions } from './monacoEditorConfig'

import { joinClassNames } from '../../../utils/styles'
import styles from './custom-monaco-editor.module.scss'

interface ICustomMonacoEditor {
    value: string
    handleEditorChange: (value: string | undefined) => void
    isThemeDark: boolean
    className?: string
}

function CustomMonacoEditor(props: ICustomMonacoEditor) {
    const { value, handleEditorChange, isThemeDark, className } = props

    const monaco = useMonaco()

    useLayoutEffect(() => {
        monaco?.editor.defineTheme('dark-theme-sages', darkTheme)
    }, [monaco])

    return (
        <MonacoEditor
            height="100%"
            width="100%"
            defaultLanguage="yaml"
            value={value}
            onChange={handleEditorChange}
            theme={isThemeDark ? 'dark-theme-sages' : 'vs'}
            className={joinClassNames(styles.customMonacoEditor, className)}
            options={monacoOptions}
        />
    )
}

export default CustomMonacoEditor
